import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { PublicLayout } from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import ServicesPage from "@/pages/ServicesPage";
import ServiceDetailPage from "@/pages/ServiceDetailPage";
import ProductsPage from "@/pages/ProductsPage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import IndustriesPage from "@/pages/IndustriesPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import NotFoundPage from "@/pages/NotFoundPage";
import { AuthProvider } from "@/admin/AuthContext";
import { AdminLayout } from "@/admin/AdminLayout";
import AdminLoginPage from "@/admin/AdminLoginPage";
import AdminDashboardPage from "@/admin/AdminDashboardPage";
import AdminInquiriesPage from "@/admin/AdminInquiriesPage";
import AdminSettingsPage from "@/admin/AdminSettingsPage";
import { ServicesAdmin, ProductsAdmin, IndustriesAdmin, TestimonialsAdmin, FaqsAdmin } from "@/admin/contentPages";

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route element={<PublicLayout />}>
                <Route index element={<HomePage />} />
                <Route path="/services" element={<ServicesPage />} />
                <Route path="/services/:slug" element={<ServiceDetailPage />} />
                <Route path="/products" element={<ProductsPage />} />
                <Route path="/products/:slug" element={<ProductDetailPage />} />
                <Route path="/industries" element={<IndustriesPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Route>
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboardPage />} />
                <Route path="inquiries" element={<AdminInquiriesPage />} />
                <Route path="services" element={<ServicesAdmin />} />
                <Route path="products" element={<ProductsAdmin />} />
                <Route path="industries" element={<IndustriesAdmin />} />
                <Route path="testimonials" element={<TestimonialsAdmin />} />
                <Route path="faqs" element={<FaqsAdmin />} />
                <Route path="settings" element={<AdminSettingsPage />} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors closeButton />
        </div>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
